import React, { useEffect, useState } from 'react';
import { FileText, Megaphone, Users, Clock } from 'lucide-react';
import { getBlogs, getAds, getUsers } from '../services/api';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user, isAdmin } = useAuth();
  const [stats, setStats] = useState({ activeBlogs: 0, pendingBlogs: 0, activeAds: 0, totalUsers: 0 });

  useEffect(() => {
    // Only fetch stats if the user is an admin
    if (isAdmin) {
      const fetchStats = async () => {
        const [allBlogs, activeAdsAPI, allUsers] = await Promise.all([
           getBlogs("all"),
           getAds(),
           getUsers()
        ]);
        
        setStats({
          activeBlogs: allBlogs.filter(b => b.status === "published").length,
          pendingBlogs: allBlogs.filter(b => b.status === "pending").length,
          activeAds: activeAdsAPI.filter(a => a.status === "active").length,
          totalUsers: allUsers.length
        });
      };
      fetchStats();
    }
  }, [isAdmin]);

  const cards = [
    { title: "Published Blogs", value: stats.activeBlogs, icon: <FileText className="w-8 h-8 text-blue-500" />, bg: "bg-blue-50", border: "border-blue-200" },
    { title: "Pending Approvals", value: stats.pendingBlogs, icon: <Clock className="w-8 h-8 text-amber-500" />, bg: "bg-amber-50", border: "border-amber-200" },
    { title: "Active Campaigns", value: stats.activeAds, icon: <Megaphone className="w-8 h-8 text-green-500" />, bg: "bg-green-50", border: "border-green-200" },
    { title: "Total Users", value: stats.totalUsers, icon: <Users className="w-8 h-8 text-purple-500" />, bg: "bg-purple-50", border: "border-purple-200" },
  ];

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-stone-900 mb-2">
        {isAdmin ? 'Overview Dashboard' : 'User Dashboard'}
      </h1>
      <p className="text-stone-500 mb-10">
        {isAdmin 
          ? 'Welcome to the Nathnagri unified CMS command center.' 
          : `Welcome, ${user?.name || 'User'}! Manage your content here.`}
      </p>

      {isAdmin && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map(card => (
            <div key={card.title} className={`${card.bg} border ${card.border} rounded-3xl p-6 flex flex-col justify-between shadow-sm`}>
              <div className="flex justify-between items-start mb-4">
                <div className="bg-white p-3 rounded-2xl shadow-sm">{card.icon}</div>
              </div>
              <div>
                <h3 className="text-stone-500 font-medium text-sm mb-1">{card.title}</h3>
                <p className="text-4xl font-extrabold text-stone-900 tracking-tight">{card.value}</p>
              </div>
            </div>
          ))}
        </div>
      )}
      
      <div className="mt-12 bg-stone-100 rounded-3xl border border-stone-200 p-8 flex flex-col items-center justify-center text-center">
        <h3 className="text-xl font-bold text-stone-800 mb-2">Quick Actions</h3>
        <p className="text-stone-600 mb-6">Navigate through the left sidebar to manage specific modules.</p>
        <span className="px-4 py-2 bg-saffron-100 text-saffron-800 rounded-xl font-semibold border border-saffron-200 inline-block shadow-sm">
          System Status: Online
        </span>
      </div>

    </div>
  );
};

export default Dashboard;
